﻿import { opaccAjaxPlugin } from "./vendor/script/opacc.static.js";

class ELECourseSelect extends HTMLElement {
  constructor() {
    super();
    this.initValue = this.hasAttribute("data-url");
    this.selectors = this.querySelectorAll("[data-course-selector]");
    this.links = this.querySelectorAll("[data-course-select-link]");
    this.showAllCheckbox =
      this.querySelector("[data-select-showall") || undefined;
    this.resultContainer = this.querySelector("[data-select-result-container]");

    this.placeTitle =
      this.querySelector("[data-select-place-text]") || undefined;
    this.placeLabel =
      this.querySelector("[data-select-place-label]") || undefined;
    this.dateTitle =
      this.querySelector("[data-select-date-title]") || undefined;
    this.dateLabel =
      this.querySelector("[data-select-date-label]") || undefined;
    this.isLoading = true;
  }

  connectedCallback() {
    if (this.selectors.length === 0 || this.links.length === 0) return;
    this.registerListener();
    this.setInitState();
    this.initResult = this.resultContainer.innerHTML;
  }

  registerListener() {
    this.registerLinkListener();
    this.showAllCheckbox &&
      this.showAllCheckbox.addEventListener(
        "change",
        this.setFormField.bind(this)
      );
  }

  registerLinkListener(elementList = this.links) {
    const clickHandler = this.clickHandler.bind(this);

    elementList.forEach((link) => {
      link.addEventListener("click", clickHandler);
    });
  }

  clickHandler(e) {
    const link = e.target.closest("[data-course-select-link]");
    this.fetchContent(link);
  }

  async fetchContent(target) {
    const url = target.getAttribute("data-url");

    if (!url) throw new Error("ELECourseSelect: missing URL");

    const updateContent = this.updateContent.bind(this, target);
    opaccAjaxPlugin.fetchAsynGetJson(
      url,
      updateContent,
      this.getDefaultErrorFnc(),
      true
    );
  }

  setInitState() {
    // single place
    const placeItemsContainer = this.querySelector("[data-select-place-count]");
    const placeItemsCount = placeItemsContainer.getAttribute(
      "data-select-place-count"
    );
    const accordion = placeItemsContainer.closest("[data-course-selector]");
    accordion.enable();

    if (placeItemsCount === "1") {
      accordion.disable();
      placeItemsContainer.firstElementChild.click();
    } else if (this.initValue) {
      this.fetchContent(this);
    } else {
      this.loaded();
    }
  }

  updateContent(target, response) {
    const targetId = target.getAttribute("data-course-target-id");
    const targetElement = this.querySelector(`#${targetId}`);

    if (response.contentType === "text/html") {
      this.selectPlace(target, targetElement, false, response.dataAsHtml);
    } else if (response.contentType === "application/json") {
      this.selectDate(targetElement, response.dataAsJson);
    }
  }

  selectPlace(target, targetElement, isInit = false, content) {
    if (isInit) {
      targetElement.innerHTML = content.dataAsHtml;
    } else {
      this.clearResult();
      targetElement.innerHTML = content;

      const headerText = target.querySelector(
        "[data-course-title]"
      ).textContent;
      this.setHeaderText(this.placeTitle, headerText);

      const labelText =
        targetElement.firstElementChild.getAttribute("data-row-count");
      this.placeLabelElement = document.createElement("div");
      this.placeLabelElement.classList.add(
        "accordion__flag",
        "accordion__flag--border"
      );
      this.placeLabelElement.textContent = labelText;
      this.placeLabel.insertAdjacentElement(
        "afterbegin",
        this.placeLabelElement
      );
    }

    this.registerLinkListener(
      targetElement.querySelectorAll("[data-course-select-link]")
    );

    this.dateTitle.closest("ele-accordion").classList.add("accordion--active");

    // activate course if only one option
    const dateItemsContainer = this.querySelector("[data-select-date-count]");
    const dateItemsCount = dateItemsContainer.getAttribute(
      "data-select-date-count"
    );
    const accordion = dateItemsContainer.closest("[data-course-selector]");
    accordion.enable();

    if (dateItemsCount === "1") {
      accordion.disable();
      dateItemsContainer.firstElementChild.click();
    } else {
      this.loaded();
    }
  }

  getDefaultErrorFnc() {
    return;
  }

  selectDate(target, json) {
    this.clearResult();

    if (json.dateURL) {
      const targetElement = this.querySelector(`#course-select-date`);

      const selectPlace = this.selectPlace.bind(
        this,
        null,
        targetElement,
        true
      );
      opaccAjaxPlugin.fetchAsynGetJson(
        json.dateURL,
        selectPlace,
        this.getDefaultErrorFnc(),
        true
      );
    }

    this.placeLabelElement && this.placeLabelElement.remove();

    target.innerHTML = this.decodeHtml(atob(json.courseDetail));

    this.buttonContainer = document.createElement("div");
    this.buttonContainer.classList.add("price-tile__button");
    this.buttonContainer.insertAdjacentHTML(
      "beforeend",
      this.decodeHtml(atob(json.button))
    );
    this.firstElementChild.insertAdjacentElement(
      "beforeend",
      this.buttonContainer
    );

    this.artNoContainer = document.createElement("div");
    this.artNoContainer.classList.add("course-select__no");
    this.artNoContainer.insertAdjacentText("beforeend", json.artNo);
    this.insertAdjacentElement("beforeend", this.artNoContainer);

    const labelText = json.capacity;
    this.dateLabelElement = document.createElement("div");
    this.dateLabelElement.classList.add(
      "accordion__flag",
      "accordion__flag--border"
    );
    this.dateLabelElement.textContent = labelText;
    this.dateLabel.insertAdjacentElement("afterbegin", this.dateLabelElement);

    this.setHeaderText(this.placeTitle, json.place);
    this.setHeaderText(this.dateTitle, json.startDate, false);

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("courseNo", json.artInternalNo);
    window.history.pushState(
      null,
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );

    if (this.isLoading) this.loaded();
  }

  setHeaderText(element, text, closeAccordion = true) {
    const titelElement = element.querySelector("[data-select-title]");
    titelElement.textContent = text;

    element.classList.add("accordion__text--is-selected");

    if (!closeAccordion) return;
    const accordion = element.closest("ele-accordion");
    accordion.classList.remove("accordion--active");
  }

  setFormField() {
    const url = location.href;
    const data = {
      showAllCourses: this.showAllCheckbox.checked,
    };
    if (!url) return;
    opaccAjaxPlugin.fetchAsynPostForm(url, data, () =>
      window.location.reload(true)
    );
  }

  clearResult() {
    this.placeLabelElement && this.placeLabelElement.remove();
    this.dateLabelElement && this.dateLabelElement.remove();
    this.resultContainer.innerHTML = this.initResult;
    this.buttonContainer && this.buttonContainer.remove();
    this.artNoContainer && this.artNoContainer.remove();
    this.dateTitle.classList.remove("accordion__text--is-selected");
  }

  decodeHtml(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  loaded() {
    this.isLoading = false;
    this.classList.remove("course-select--loading");
  }
}

customElements.define("ele-course-select", ELECourseSelect);




